<script setup>
// 图集
import { computed } from 'vue'

const props = defineProps({
  mode: { type: String, default: 'horizontal' }, // horizontal | vertical
  images: { type: Array, default: () => [] }
})

defineEmits(['imgClick'])

const showImages = computed(() =>
  props.mode === 'horizontal' ? props.images.slice(0, 5) : props.images
)
const remainder = computed(() => (props.images.length > 5 ? props.images.length - 5 : 0))
const getHClassName = (index) => {
  const length = showImages.value.length
  switch (length) {
    case 1:
      return 'col-span-12'
    case 2:
      return 'col-span-6'
    case 3:
      return 'col-span-4'
    case 4:
      return 'col-span-6'
    default:
      if (index === 0 || index === 1) return 'col-span-6'
      return 'col-span-4'
  }
}
</script>

<template>
  <div class="tvb-photo-gallery">
    <div v-if="mode === 'horizontal'" class="photo-gallery-horizontal">
      <template v-for="(img, idx) in showImages" :key="idx">
        <tvb-router-link
          :to="img.jump_url"
          v-bind="
            img.jump_url ? { linkRel: img.rel ? 2 : 1, linkTarget: img.target ? 2 : 1 } : null
          "
          class="photo-gallery__image-wrap"
          :class="getHClassName(idx)"
          @click="$emit('imgClick', img)"
        >
          <!-- <tvb-image
            class="photo-gallery__cover"
            :src="img.thumb"
            :alt="img.image_alt_text"
          ></tvb-image> -->
          <img class="photo-gallery__cover" v-lazy="img.thumb.medium" :alt="img.image_alt_text" />
          <div
            v-if="showImages.length === idx + 1 && remainder > 0"
            class="photo-gallery__remainder"
          >
            +{{ remainder }}
          </div>
        </tvb-router-link>
      </template>
    </div>
    <div v-if="mode === 'vertical'" class="photo-gallery-vertical">
      <template v-for="(img, idx) in showImages" :key="idx">
        <figure>
          <tvb-router-link
            :to="img.jump_url"
            v-bind="
              img.jump_url ? { linkRel: img.rel ? 2 : 1, linkTarget: img.target ? 2 : 1 } : null
            "
            class="photo-gallery__image-wrap"
            :class="{ 'tvb-img_href': img.jump_url }"
            @click="$emit('imgClick', img)"
          >
            <!-- <tvb-image
              class="photo-gallery__cover"
              :src="img.thumb"
              :alt="img.image_alt_text"
            ></tvb-image> -->
            <img class="photo-gallery__cover" v-lazy="img.thumb.medium" :alt="img.image_alt_text" />
          </tvb-router-link>
          <figcaption v-if="img.description" class="tvb-img_des">{{ img.description }}</figcaption>
        </figure>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.tvb-photo-gallery {
  .photo-gallery-horizontal {
    display: grid;
    grid-auto-flow: row;
    grid-template-columns: repeat(12, minmax(0px, 1fr));
    gap: 0.25rem;

    .col-span-12 {
      grid-column: span 12 / span 12;
    }
    .col-span-6 {
      grid-column: span 6 / span 6;
    }
    .col-span-4 {
      grid-column: span 4 / span 4;
    }

    .photo-gallery__image-wrap {
      position: relative;
      padding-top: 75%; // 2:1.5
    }

    .photo-gallery__cover {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .photo-gallery-vertical {
    display: grid;
    gap: var(--tvb-editor-view-img-padding);
    .photo-gallery__image-wrap {
      img[lazy='error'],
      img[lazy='loading'] {
        aspect-ratio: 16 / 9;
      }
    }
    .photo-gallery__cover {
      max-width: 100%;
      width: 100%;
    }
  }

  .photo-gallery__image-wrap {
    cursor: pointer;
    font-size: 0;
    img[lazy='error'],
    img[lazy='loading'] {
      padding: 0 calc(50% - (98px / 2));
      object-fit: contain;
    }
  }

  .photo-gallery__cover {
    background-color: #f8f9fa;
  }

  .photo-gallery__remainder {
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgba(255, 255, 255, 0.9);
    font-size: 28px;
    position: absolute;
    inset: 0px;
    background-color: rgb(0 0 0 / 0.4);
  }

  &.mobile {
    .photo-gallery-horizontal {
      gap: 3px;
    }
    .photo-gallery__remainder {
      font-size: 20px;
    }
  }
}
</style>
